var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"h-auto",attrs:{"width":_vm.width,"viewBox":"0 0 50 50","preserveAspectRatio":"xMidYMid meet"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('g',{attrs:{"fill":_vm.fill}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }